import { useEffect, useState } from 'react';
import { generateFormField } from '../../../utils/form/generate-form-fields/generate-form-fields';
import { errorMessages } from '../../../utils/error-messages';
import { ConfigurationFromPdfFieldNames } from '../configuration-from-pdf.types';
import cloneDeep from 'lodash/cloneDeep';
import { UseFormReturn } from 'react-hook-form';
import useCarModelsByCarBrand from '../../../hooks/react-query/use-car-models-by-car-brand';

const useCarModelFields = (reactHookFormData: UseFormReturn) => {
  const { getValues, setValue } = reactHookFormData;

  const [carModelFields, setCarModelFields] = useState([
    generateFormField.lookup({
      label: 'Modell',
      name: ConfigurationFromPdfFieldNames.CarModel,
      validation: {
        required: errorMessages.requiredOptionSet
      }
    })
  ]);

  const carBrandValue = getValues(ConfigurationFromPdfFieldNames.CarBrand);
  const { carModels } = useCarModelsByCarBrand(carBrandValue);

  useEffect(() => {
    if (carModels) {
      const newCarModelFields = cloneDeep(carModelFields);
      newCarModelFields[0].options = carModels.map(item => ({ value: item.uds_carmodelid, label: item.uds_name }));
      setCarModelFields(newCarModelFields);
    }
  }, [carModels]);

  useEffect(() => {
    setValue(ConfigurationFromPdfFieldNames.CarModel, '');
    if (!carBrandValue) {
      const newCarModelFields = cloneDeep(carModelFields);
      newCarModelFields[0].options = [];
      setCarModelFields(newCarModelFields);
    }
  }, [carBrandValue]);

  return { carModelFields };
};

export default useCarModelFields;
